import React from 'react';
import clas from 'classnames';
interface Props {
    url?: string;
    onClose?: () => void;
}

const CanCloseImage: React.FC<Props> = ({ url, onClose }) => {
    const icon = (
        <svg className="close-icon" onClick={onClose} xmlns="http://www.w3.org/2000/svg" width="15" height="14" viewBox="0 0 15 14" fill="none">
            <path
                d="M7.5 13.5C11.0899 13.5 14 10.5899 14 7C14 3.41015 11.0899 0.5 7.5 0.5C3.91015 0.5 1 3.41015 1 7C1 10.5899 3.91015 13.5 7.5 13.5Z"
                fill="#707070"
            />
            <path d="M10 9.5L5 4.5" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M10 4.5L5 9.5" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
    return !!url ? (
        <div className={clas('B-can-close-image')}>
            {icon}
            <img src={url} style={{ objectFit: 'scale-down' }} alt="" />
        </div>
    ) : null;
};
export default CanCloseImage;
